import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const PROOFIcon = ({ color = '#FFF', size = 14, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 280 80"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <text
        xmlSpace="preserve"
        fontSize="91"
        fill={color}
        fillRule="nonzero"
        transform="matrix(.8 0 0 .8 125 40)"
      >
        <tspan x="-153.88" y="28.59">
          PROOF
        </tspan>
      </text>
    </g>
  </svg>
);

PROOFIcon.propTypes = propTypes;

export default PROOFIcon;
